import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { Observable, skip, take, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { Constants } from "src/app/shared/data/constants";
import { Authorities } from "src/app/shared/enum/authorities";
import { RefreshButtonState } from "src/app/shared/enum/refreshButtonState";
import { DateFilter } from "src/app/shared/models/date-filte.interface";
import { FilterParams } from "src/app/shared/models/filterParams";
import { TopFranchised, TopFranchisedResult, TopFranchiseRequest } from "src/app/shared/models/franchise/topFranchised.interface";
import { FiltersService } from "src/app/shared/services/filters.service";
import { JwtService } from "src/app/shared/services/jwt.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeTopFranchised } from "src/app/store/franchise/franchise.action";
import { resultTopFranchisedSelector } from "src/app/store/franchise/franchise.selectors";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-top-franchised",
  templateUrl: "./top-franchised.component.html",
})
export class TopFranchisedComponent extends BaseComponent implements OnInit {
  forbidden: boolean | null = false;
  fetchingLocationPartnerPreviewState: RefreshButtonState =
    RefreshButtonState.IDLE;
  cachedAt: Date | null = null;
  loading: boolean = true;

  topFranchised$: Observable<TopFranchisedResult | null>;
  topFranchised: TopFranchised[] = [];

  formFilter: FormGroup;
  dateFilter: DateFilter = {
    startDate: null,
    endDate: null,
  };

  filters: FilterParams | null;

  today = new Date();
  startDate = Constants.sevenDaysAgo
  constructor(
    private fb: FormBuilder,
    private store: Store<AppStateInterface>,
    private filtersService: FiltersService,
    private jwtService: JwtService
  ) {
    super(store);
    this.formFilter = this.fb.group({
      date: [[this.startDate, this.today]],
    });
    this.topFranchised$ = this.store
      .pipe(select(resultTopFranchisedSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.forbidden = !authorities.includes(
        Authorities.FR_TOP_FRANCHISED.toString()
      );
    }
    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();

    this.filtersService.patchFormValue(this.filters, ["date"], this.formFilter);
  }

  ngOnInit(): void {
    this.dateFilter = {
      startDate: this.formFilter.get("date")?.value[0],
      endDate: this.formFilter.get("date")?.value[1],
    };
    this.fetchTopFranchised(false);
    this.topFranchised$.subscribe((result) => {
      if (result) {
        this.loading = false
        this.topFranchised = result.topFranchised;
        this.cachedAt = result.cachedAt
      }
    });
    this.formFilter.valueChanges.subscribe((value) => {
      this.dateFilter = {
        startDate: value.date[0],
        endDate: value.date[1],
      };
      this.fetchTopFranchised(false);
    });
  }

  onClickRefreshCache() {
    this.fetchingLocationPartnerPreviewState = RefreshButtonState.LOADING;
    this.fetchTopFranchised(true);
  }

  fetchTopFranchised(refreshCache: boolean) {
    this.loading = true
    const request : TopFranchiseRequest = {
      limit : 5,
      dateFilter : this.dateFilter
    }
    if (refreshCache) {
      this.topFranchised$.pipe(skip(1), take(1)).subscribe((result) => {
        if (result) {
          this.fetchingLocationPartnerPreviewState = RefreshButtonState.SUCCESS;
          setTimeout(
            () =>
              (this.fetchingLocationPartnerPreviewState =
                RefreshButtonState.IDLE),
            2500
          );
        } else {
          this.fetchingLocationPartnerPreviewState = RefreshButtonState.LOADING;
        }
      });
    }
    this.store.dispatch(
      invokeTopFranchised({
        refreshCache: refreshCache,
        request: request
      })
    );
  }
}
